type SunriseArcProps = {
  size?: number;
  stroke?: number;
  color?: string;
};

export function SunriseArc({ size = 56, stroke = 2.5, color }: SunriseArcProps) {
  const c = color ?? "var(--accent)";
  const h = size * 0.7;
  return (
    <svg
      width={size}
      height={h}
      viewBox="0 0 80 56"
      fill="none"
      aria-hidden="true"
      style={{ display: "block" }}
    >
      <path d="M8 42 A 32 32 0 0 1 72 42" stroke={c} strokeWidth={stroke} strokeLinecap="round" fill="none" />
      <line x1="4" y1="50" x2="76" y2="50" stroke="var(--text)" strokeWidth={stroke * 0.55} strokeLinecap="round" />
      <line
        x1="14"
        y1="54.5"
        x2="66"
        y2="54.5"
        stroke="var(--text)"
        strokeWidth={stroke * 0.4}
        strokeLinecap="round"
        opacity="0.45"
      />
    </svg>
  );
}
